import { NavLink } from 'react-router-dom';
import { Home, FolderOpen, Heart, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

export const MobileNav = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t bg-background px-4 py-2 md:hidden">
      <nav className="flex items-center justify-around">
        <NavLink
          to="/"
          className={({ isActive }) =>
            cn(
              'flex flex-col items-center gap-1 p-2 transition-colors',
              isActive ? 'text-primary' : 'text-muted-foreground'
            )
          }
        >
          <Home className="h-5 w-5" />
          <span className="text-[10px] font-medium">Home</span>
        </NavLink>

        <NavLink
          to="/folders"
          className={({ isActive }) =>
            cn(
              'flex flex-col items-center gap-1 p-2 transition-colors',
              isActive ? 'text-primary' : 'text-muted-foreground'
            )
          }
        >
          <FolderOpen className="h-5 w-5" />
          <span className="text-[10px] font-medium">Folders</span>
        </NavLink>

        <NavLink
          to="/favorites"
          className={({ isActive }) =>
            cn(
              'flex flex-col items-center gap-1 p-2 transition-colors',
              isActive ? 'text-primary' : 'text-muted-foreground'
            )
          }
        >
          <Heart className="h-5 w-5" />
          <span className="text-[10px] font-medium">Saved</span>
        </NavLink>

        <NavLink
          to="/settings"
          className={({ isActive }) =>
            cn(
              'flex flex-col items-center gap-1 p-2 transition-colors',
              isActive ? 'text-primary' : 'text-muted-foreground'
            )
          }
        >
          <Settings className="h-5 w-5" />
          <span className="text-[10px] font-medium">Settings</span>
        </NavLink>
      </nav>
    </div>
  );
};
